import React from 'react';
import { Users, Award, Clock, DollarSign } from 'lucide-react';

const stats = [
  {
    name: 'Active Users',
    value: '2,000+',
    description: 'Government contractors',
    icon: Users,
  },
  {
    name: 'Contracts Managed',
    value: '$500M+',
    description: 'Total contract value',
    icon: DollarSign,
  },
  {
    name: 'Average Win Rate',
    value: '32%',
    description: 'Above industry average',
    icon: Award,
  },
  {
    name: 'Time Saved',
    value: '60%',
    description: 'In proposal preparation',
    icon: Clock,
  },
];

export function Stats() {
  return (
    <div className="relative bg-gradient-to-b from-purple-50 to-white">
      <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white to-transparent" />
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="relative">
          <div className="absolute inset-0 flex items-center" aria-hidden="true">
            <div className="w-full border-t border-purple-200"></div>
          </div>
        </div>

        <div className="relative mx-auto max-w-7xl py-12 px-6 sm:py-16 lg:px-8">
          <div className="relative rounded-3xl bg-white/50 backdrop-blur-lg ring-1 ring-purple-900/5 shadow-xl">
            <div className="absolute inset-0">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-purple-500 opacity-90" />
            </div>
            <div className="relative mx-auto max-w-7xl py-12 px-6 sm:py-16 lg:px-8">
              <div className="grid grid-cols-1 gap-y-12 gap-x-8 sm:grid-cols-2 lg:grid-cols-4">
                {stats.map((stat) => {
                  const Icon = stat.icon;
                  return (
                    <div
                      key={stat.name}
                      className="text-center"
                    >
                      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-xl bg-white/10 backdrop-blur">
                        <Icon className="h-8 w-8 text-white" />
                      </div>
                      <div className="mt-3">
                        <div className="text-3xl font-bold text-white">{stat.value}</div>
                        <div className="text-base font-semibold text-white">{stat.name}</div>
                        <div className="mt-1 text-sm text-white/80">{stat.description}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}